export function showToast(message, type = 'success', duration = 3000) {
    const container = document.getElementById('toast-container');
    if (!container) {
        console.error('Toast container not found!');
        return;
    }

    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.textContent = message;

    container.appendChild(toast);

    // Animate in: Use requestAnimationFrame to ensure the element is painted before adding the 'show' class
    requestAnimationFrame(() => {
        toast.classList.add('show');
    });

    // Animate out and remove
    setTimeout(() => {
        toast.classList.remove('show');
        
        // Remove the element after the transition is complete
        toast.addEventListener('transitionend', () => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
        });
    }, duration);
}
